module.exports = __webpack_public_path__ + "img/partner02.64728301.png";